import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=c22fb4dc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=c22fb4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22fb4dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c22fb4dc')) {
      api.createRecord('c22fb4dc', component.options)
    } else {
      api.reload('c22fb4dc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=c22fb4dc&scoped=true&", function () {
      api.rerender('c22fb4dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MoLBS243NdfA/JS/comp/Voucher.vue"
export default component.exports